module.exports = __webpack_public_path__ + "static/advice8-d51b880ea5c9b20cf05a1bd4de21ab8e.png";